import React from "react";
import { Card, Tag } from "antd";
import { PIPELINE_STEPS } from "variables/constants";
import { getNameInitials } from "utils/index";
import {
    MapPin,
    Clock,
} from "lucide-react";

const CandidateCard = ({
    recordData,
    role,
    skills = [],
    onClick,
    selected = false,
    stage = "Application",
    code,
}) => {
    const StageIcon = PIPELINE_STEPS[stage];    

    return (
        <Card
            hoverable
            onClick={onClick}
            className={`!rounded-2xl !border-2 transition-all duration-300 cursor-pointer ${
                selected
                    ? "!border-emerald-500 !bg-gradient-to-br from-emerald-50 to-cyan-50"
                    : "!border-slate-200 hover:!border-emerald-300"
                }`}
        >
            <div className="flex flex-col space-y-3">
                <div className="flex justify-between items-start">
                    <div className="flex items-start gap-3">
                        <span 
                            className={`relative flex w-12 h-12 shrink-0 overflow-hidden rounded-full border-2 border-white shadow-md  ${
                                selected
                                    ? "bg-gradient-to-br from-emerald-500 to-cyan-500"
                                    : "bg-emerald-100"
                                }`}
                        >
                            <span className={`flex size-full items-center justify-center font-semibold text-[14px] ${
                                selected
                                    ? "text-white"
                                    : "text-emerald-800"
                                }`}
                            >
                                { getNameInitials(recordData?.applicant_name) }
                            </span>
                        </span>

                        <div className="flex-1 min-w-0">
                            <h4 className={`font-semibold text-[13px] sm:text-[15px] text-slate-900`}>
                                {recordData?.applicant_name}
                            </h4>
                            <p className="text-[12px] text-slate-700">{recordData?.job_post_title}</p>

                            <div className="flex items-center gap-3 text-[12px] text-slate-700 mt-1">
                                {recordData?.applicant_location && (
                                    <span className="flex items-center gap-1">
                                        <MapPin className="w-3 h-3 text-gray-400" />
                                        {recordData.applicant_location}
                                    </span>
                                )}
                                {recordData?.applicant?.apl_xp_years && (
                                    <span className="flex items-center gap-1">
                                        <Clock className="w-3 h-3 text-slate-700" />
                                        {recordData.applicant.apl_xp_years} yrs
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                    <span
                        className={`status-indicator normal text-[9px] ${
                            selected ? "bg-gradient-to-br from-emerald-50 to-cyan-50" : ""
                        }`}
                    >
                        { recordData?.job_code }
                    </span>

                </div>

                <div>
                    <div className="flex justify-between items-center mb-1 text-[12px]">
                        <div className="flex items-center gap-1 text-gray-800">
                            {StageIcon && <StageIcon className="w-3 h-3 text-emerald-600" />}
                            <span className="font-medium">{recordData?.pipeline_name}</span>
                        </div>
                        {recordData?.application_progress && (
                            <span className="text-slate-700">{recordData.application_progress}%</span>
                        )}
                    </div>

                    <div className="w-full h-2 rounded-full bg-slate-200 overflow-hidden">
                        <div
                            className={`h-full rounded-full pipeline-steps ${recordData?.pipeline_name?.toLowerCase().replace(/\s+/g, '-')}`}
                            style={{ width: `${recordData?.application_progress }%` }}
                        />
                    </div>
                </div>

                {recordData?.skills?.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                        {recordData.skills.slice(0, 3).map((skill, i) => (
                            <Tag
                                key={i}
                                className="!text-[11px] !py-0.5 !px-2 !rounded-lg !bg-gray-50 !border-none !text-gray-800"
                            >
                                {skill}
                            </Tag>
                        ))}
                        {recordData.skills.length > 3 && (
                            <Tag className="!text-[11px] !py-0.5 !px-2 !rounded-lg !bg-gray-50 !border-none !text-gray-800">
                                +{skills.length - 3} more
                            </Tag>
                        )}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default CandidateCard;
